import { Component, Directive, OnDestroy } from '@angular/core';
import { FormElementComponent } from '@kalidea/kaligraphi';
import { Subject } from 'rxjs';
import { applyMixins } from './apply-mixins';
import { SubscriptionManager } from './subscription-manager';

/**
 * create custom FormElementComponent merged with SubscriptionManager
 */
// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface CustomFormElement<T> extends SubscriptionManager {
}

@Directive()
export class CustomFormElement<T> extends FormElementComponent<T> implements OnDestroy {

    protected readonly closedSubject = new Subject<void>();

    ngOnDestroy() {
        this.valueChanges.complete();
        this.inputChanges.complete();
        this.closedSubject.next();
        this.closedSubject.complete();
    }

}

applyMixins(CustomFormElement, [SubscriptionManager, FormElementComponent]);



